(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["herspace-ticket-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.getElementById('hs-ticket-popup');
    if (!popup || typeof popup.showModal !== 'function' || window.Shopify?.designMode) return;
    const expires = Date.parse('2026-10-16T00:00:00-05:00');
    const key = 'herspace-ticket-presale-oct15-repeat-v2';
    let nextShow = Date.now() + 5000;
    const remember = () => {
      nextShow = Date.now() + 60000;
      try { localStorage.setItem(key, String(nextShow)); } catch {}
    };
    const show = () => {
      if (Date.now() >= expires) { window.clearInterval(timer); return; }
      let due = nextShow;
      try { due = Math.max(due, Number(localStorage.getItem(key) || 0)); } catch {}
      if (Date.now() < due || document.visibilityState !== 'visible' || document.querySelector('dialog[open]')) return;
      popup.showModal();
      remember();
    };
    const close = () => popup.close();
    popup.querySelector('.hs-ticket-close').addEventListener('click', close);
    popup.querySelector('.hs-ticket-later').addEventListener('click', close);
    popup.addEventListener('close', remember);
    popup.querySelector('.hs-ticket-cta').addEventListener('click', () => { remember(); popup.close(); });
    const timer = window.setInterval(show, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
